import { render } from "./SignaturePad.vue?vue&type=template&id=f9a484c6&scoped=true"
import script from "./SignaturePad.vue?vue&type=script&lang=js"
export * from "./SignaturePad.vue?vue&type=script&lang=js"

import "./SignaturePad.vue?vue&type=style&index=0&id=f9a484c6&scoped=true&lang=css"

import exportComponent from "../../../client-congress/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9a484c6"]])

export default __exports__